import { type PaymentMethod } from '~shared/types';
import { type APIError } from '~shared/types/APIError';

/**
 * Fetch payment methods success action — dispatched by the paymentMethods.fetchAll queryFn
 * (React Query) so the Redux slice read by the getOrder / shipment payment Reselect selectors
 * stays in sync with the query cache.
 */
export const FETCH_PAYMENT_METHODS_SUCCEEDED = 'FETCH_PAYMENT_METHODS_SUCCEEDED';

type ActionFetchPaymentMethodsSucceeded = {
  type: typeof FETCH_PAYMENT_METHODS_SUCCEEDED;
  payload: PaymentMethod[];
};

export const fetchPaymentMethodsSucceeded = (paymentMethods: PaymentMethod[]): ActionFetchPaymentMethodsSucceeded => ({
  type: FETCH_PAYMENT_METHODS_SUCCEEDED,
  payload: paymentMethods,
});

/**
 * Fetch payment methods failed action
 */
export const FETCH_PAYMENT_METHODS_FAILED = 'FETCH_PAYMENT_METHODS_FAILED';

type ActionFetchPaymentMethodsFailed = {
  type: typeof FETCH_PAYMENT_METHODS_FAILED;
  payload: APIError;
  error: true;
};

export const fetchPaymentMethodsFailed = (error: APIError): ActionFetchPaymentMethodsFailed => ({
  type: FETCH_PAYMENT_METHODS_FAILED,
  payload: error,
  error: true,
});

/**
 * Create payment method succeeded action — dispatched by the useCreate*PaymentMethod
 * mutations (React Query) on success so the paymentMethods slice stays in sync without
 * waiting for the invalidated query to refetch.
 */
export const CREATE_PAYMENT_METHOD_SUCCEEDED = 'CREATE_PAYMENT_METHOD_SUCCEEDED';

export type ActionCreatePaymentMethodSucceeded = {
  type: typeof CREATE_PAYMENT_METHOD_SUCCEEDED;
  payload: PaymentMethod;
};

export const createPaymentMethodSucceeded = (paymentMethod: PaymentMethod): ActionCreatePaymentMethodSucceeded => ({
  type: CREATE_PAYMENT_METHOD_SUCCEEDED,
  payload: paymentMethod,
});

/**
 * Delete payment method succeeded action — dispatched by the useDeletePaymentMethod
 * mutation (React Query) on success so checkout selectors don't briefly see the deleted
 * method while the invalidated query refetches.
 */
export const DELETE_PAYMENT_METHOD_SUCCEEDED = 'DELETE_PAYMENT_METHOD_SUCCEEDED';

export type ActionDeletePaymentMethodSucceeded = {
  type: typeof DELETE_PAYMENT_METHOD_SUCCEEDED;
  payload: PaymentMethod;
};

export const deletePaymentMethodSucceeded = (paymentMethod: PaymentMethod): ActionDeletePaymentMethodSucceeded => ({
  type: DELETE_PAYMENT_METHOD_SUCCEEDED,
  payload: paymentMethod,
});
